import sysConfig from '@/../config/sysConfig'
import path from 'path'
import store from '@/vuex/store'
import {hasPermission} from "../../../common/permission";

const userTypeKey = sysConfig.userInfoKeys.userTypes
// 超级管理员
export function sp_admin(userType) {
  return userType === userTypeKey.sp_admin
}
// 管理员
export function admin(userType) {
  return userType === userTypeKey.admin
}
// 运营商
export function operator(userType) {
  return userType === userTypeKey.operator
}
// 潜在运营商
export function pot_operator(userType) {
  return userType === userTypeKey.pot_operator
}
// 集团
export function group(userType) {
  return userType === userTypeKey.group
}
// 充电用户
export function consumer(userType) {
  return userType === userTypeKey.consumer
}
// 场站人员
export function station(userType) {
  return userType === userTypeKey.station
}

function handleGenerateRoutes(routes, permissions, basePath = '/', type = 1) {
  const res = []

  if (routes && routes instanceof Array && routes.length > 0) {
    for (const route of routes) {
      if (!route.hidden && route.meta) {
        const isLink = route.extra && route.extra.isLink
        const data = {
          path: path.resolve(basePath, route.path),
          title: route.meta.title,
          permission: route.meta.perms,
          disabled: isLink || !hasPermission(permissions, route),
          type: type
        }

        if (route.children) {
          data.children = handleGenerateRoutes(route.children, permissions, data.path, type + 1)
        }
        res.push(data)
      }
    }
  }

  return res
}

export function generateRoutes(permissions = store.getters.permissions, routes = store.getters.permission_routes) {
  return handleGenerateRoutes(routes, permissions)
}



// WEBPACK FOOTER //
// ./src/module/systemManagement/util/user.js